import { Component } from '@angular/core';

@Component({
  selector: 'app-e-notification',
  standalone: false,
  templateUrl: './auth-notifications.component.html'
})
export class AuthNotificationsComponent {

}
